import React, { FC } from "react";
import { LoginView } from "components/auth/LoginView";

export const LoginPage: FC = () => <LoginView />;
